
<h2 mat-dialog-title>Choose an Image</h2>
<mat-dialog-content fxLayout="row">
   
    <app-image-upload [images]="passedData.images" choseMode="true" (imageChosen)="passedData.chosen = $event"></app-image-upload>
   
</mat-dialog-content>
